import { Component,  EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';  
import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions, UploadStatus } from 'ngx-uploader';
import { ImageUploadSettings } from './image-upload-settings';  
import { ToastService } from '../../services/toastr-service';  
import { CorizeBaseComponent } from '../../models/base-corize-component';
import { ImageDTO, ImageTypeEnumDTO } from 'dev-corize-api-client';    
import { CorizeEnvironment } from '../../models/corize-environment';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent extends CorizeBaseComponent implements OnInit {
  @Input() settings: ImageUploadSettings = new ImageUploadSettings(); 
  @Output() imageUploadEvent: EventEmitter<ImageDTO> = new EventEmitter<ImageDTO>();
  @Output() imagePreviewEvent: EventEmitter<any> = new EventEmitter<any>();  
  public select_lit: string = "";
  private invalid_lit: string = "";
  private ico_lit: string = "";
  private logo_lit: string = "";
  private image_lit: string = "";
  private lit_file_uploaded: string = ""; 
  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  options: UploaderOptions;

  constructor(protected toast : ToastService, protected translateService: TranslateService, protected corize : CorizeEnvironment) {
     
    
    super(); 
    this.translateService.get('file-uploaded').subscribe(
      data => {
        this.lit_file_uploaded = data; //TODO is the way to do this??? 
      }
    );

    this.translateService.get('upload-ico').subscribe(
      data => {
        this.ico_lit = data; //TODO is the way to do this??? 
      }
    );
    this.translateService.get('upload-logo').subscribe(
      data => {
        this.logo_lit = data; //TODO is the way to do this??? 
      }
    );
    this.translateService.get('upload-image').subscribe(
      data => {
        this.image_lit = data; //TODO is the way to do this??? 
      }
    );

    this.translateService.get('invalid-file').subscribe(
      data => {
        this.invalid_lit = data; //TODO is the way to do this??? 
      }
    );
  } 

  b64toBlob(dataURI, mimetype) {
    return new Blob([this.b64toArrayBuffer(dataURI)], {
      type: mimetype
    });
  }

  b64toArrayBuffer(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return ia;
  }

  previewImage(file: any, type: any) {
    var t = this;
    const fileReader = new FileReader();
    return new Promise(resolve => {
      fileReader.readAsDataURL(file.nativeFile);
      fileReader.onload = function (e: any) {
        resolve(t.b64toBlob(e.target.result, type));
      }
    });
  }
 
  onUploadOutput(output: UploadOutput): void {

    if (output.type === 'allAddedToQueue') {
      const event: UploadInput = {
        type: this.settings.uploadType,
        url: this.settings.url,
        method: this.settings.method,
        fieldName: this.settings.field_name,
        headers: { 'Authorization': this.corize.AuthorizatioHeader },
        data: {
          type: this.settings.imageType
        }
      };
 
      this.uploadInput.emit(event);

    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
        if (this.settings.generatePreview)
        {
          this.previewImage(output.file, output.file.type).then(response => {
            var imagePreview = response;
            this.imagePreviewEvent.emit(imagePreview);  
          });    
        }
      
      this.files.push(output.file);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'cancelled' || output.type === 'removed') {
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'done') {

      if (output.file.response.isError) {
        this.toast.showError(output.file.response)
      }
      else {
        this.toast.showInfo(this.lit_file_uploaded) 
        this.imageUploadEvent.emit(output.file.response)
      }

    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      this.toast.showError(this.invalid_lit + " : " + output.file.name );
    }

    this.files = this.files.filter(file => file.progress.status !== UploadStatus.Done);
  }

  startUpload(): void {
    const event: UploadInput = {
      type: 'uploadAll',
      url: this.settings.url,
      method: 'PUT',
      data: { foo: 'bar' }
    };

    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }

  ngOnInit(): void {

    this.options = {
      concurrency: this.settings.fileConcurrency,
      maxUploads: this.settings.maxFiles,
      maxFileSize: this.settings.maxFileSize,
      allowedContentTypes: this.settings.mimeTypes

    };
    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;

    if (this.settings.caption =="" || this.settings.caption == undefined)
    {
      switch (this.settings.imageType) {
        case ImageTypeEnumDTO.Favicon:
          this.select_lit = this.ico_lit
          break;
  
        case ImageTypeEnumDTO.Logo:
          this.select_lit = this.logo_lit
          break;
  
        case ImageTypeEnumDTO.Image:
          this.select_lit = this.image_lit
          break;
      } 
    }
    else{
      this.select_lit = this.settings.caption;
    }

  }
}
